import { Pagination, Table, Tag } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import parse from 'html-react-parser';
import GlobalService from '../../../services/Global.service';
import IconBack from '../../../assets/Images/icons/icon-back';
import HRPolicyService from '../../../services/HRPolicy.service';
import PolicyService from '../../../services/Policy.service';
import RecruitmentPolicyService from '../../../services/RecruitmentPolicy.service';
import VendorPolicyService from '../../../services/VendorPolicy.service';
import CookiePolicyService from '../../../services/CookiePolicy.service';
import CCTVPolicyService from '../../../services/CCTVPolicy.service';
import DPAService from '../../../services/DPA.service';

const HistoryService = {
    privacy: {
        parameter: 'privacyPolicyNoticeHistoryId',
        service: PolicyService.getHistoryDetail,
    },
    hr: {
        parameter: 'hrPrivacyPolicyHistoryId',
        service: HRPolicyService.getHistoryDetail,
    },
    recruitment: {
        parameter: 'recruitmentPrivacyPolicyHistoryId',
        service: RecruitmentPolicyService.getHistoryDetail,
    },
    vendor: {
        parameter: 'vendorPrivacyPolicyHistoryId',
        service: VendorPolicyService.getHistoryDetail,
    },
    cookie: {
        parameter: 'cookiePolicyHistoryId',
        service: CookiePolicyService.getHistoryDetail,
    },
    cctv: {
        parameter: 'cctvPolicyHistoryId',
        service: CCTVPolicyService.getHistoryDetail,
    },
    dpa: {
        parameter: 'dpaPolicyHistoryId',
        service: DPAService.getHistoryDetail,
    },
    freeForm: {
        parameter: 'freeFormPolicyHistoryId',
        service: PolicyService.getFreeFormHistoryDetail,
    },
};

export default function HistoryPolicy() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    let lang = i18n.language;
    let { historyId, type } = useParams();
    const [historyInfo, setHistoryInfo] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState({
        page: 1,
        pageSize: 10,
        total: 0,
    });
    const [imageUrl, setImageUrl] = useState();

    useEffect(() => {
        getHistoryDetail();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [historyId]);

    const getHistoryDetail = async (pageValue) => {
        try {
            const { data } = await HistoryService[type].service({
                [HistoryService[type].parameter]: historyId,
                p: pageValue?.page ? pageValue?.page : 1,
                ps: pageValue?.pageSize ? pageValue?.pageSize : 10,
            });
            setLoading(false);
            setHistoryInfo(data?.resultData || []);
            setCurrentPage({
                page: data?.resultData.page,
                pageSize: data?.resultData.pageSize,
                total: data?.resultData.total,
            });
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };

    useEffect(() => {
        if (loading) {
            getHistoryDetail(currentPage);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage.page, currentPage.pageSize]);

    const _getTagStatus = (e) => {
        switch (e.status) {
            case 'Draft':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center px-4"
                        style={{ color: '#9A9A9A', borderColor: '#9A9A9A' }}
                    >
                        {/* {i18n.language === 'en' ? e.statusEn : e.statusTh} */}
                        {e?.status} {e?.version}
                    </Tag>
                );
            case 'Published':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center px-4 text-white"
                        style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                    >
                        {/* {i18n.language === 'en' ? e.statusEn : e.statusTh} */}
                        {e?.status} {e?.latestPublishVersion}
                    </Tag>
                );
            default:
                return '-';
        }
    };

    const getImage = async (id) => {
        if (id) {
            try {
                const { data } = await GlobalService.getImage(id);
                if (data?.resultData?.imageId) {
                    setImageUrl(
                        `data:image/png;base64,${data.resultData?.imageId}`
                    );
                }
            } catch (error) {
                console.log(error);
            }
        }
    };

    function decodeHtmlString(htmlString) {
        const parser = new DOMParser();
        const decodedString = parser.parseFromString(htmlString, 'text/html')
            .body.textContent;
        return decodedString;
    }

    const columns = [
        {
            title: <div>{t('Title')}</div>,
            dataIndex: lang === 'en' ? 'titleEn' : 'titleTh',
            key: 'title',
            width: '34%',
            className: 'align-top',
            render: (value, row, index) => {
                return <span>{value || '-'}</span>;
            },
        },
        {
            title: <div>{t('OldData')}</div>,
            dataIndex: 'oldValue',
            key: 'oldValue',
            width: '33%',
            className: 'align-top',
            render: (value, row, index) => {
                switch (row.titleEn) {
                    case 'Logo':
                        return (
                            <>
                                {row?.oldValue?.length > 0 ? (
                                    row?.oldValue?.map((item) => {
                                        return item ? (
                                            lang === 'en' ? (
                                                <div className="px-2">
                                                    {
                                                        'The image has been deleted and cannot be displayed anymore.'
                                                    }
                                                </div>
                                            ) : (
                                                <div className="px-2">
                                                    {
                                                        'รูปภาพถูกลบแล้ว ไม่สามารถแสดงภาพเดิมได้'
                                                    }
                                                </div>
                                            )
                                        ) : (
                                            '-'
                                        );
                                    })
                                ) : (
                                    <div className="text-gray-600">-</div>
                                )}
                            </>
                        );
                    default:
                        return (
                            <>
                                {row?.oldValue?.length > 0 ? (
                                    row?.oldValue?.map((item) => {
                                        return (
                                            <p
                                                className="text-gray-600 whitespace-pre-line px-2"
                                                style={{
                                                    wordBreak: 'break-word',
                                                }}
                                            >
                                                {item !== 'null'
                                                    ? parse(item || '-')
                                                    : '-'}
                                            </p>
                                        );
                                    })
                                ) : (
                                    <div className="text-gray-600">-</div>
                                )}
                            </>
                        );
                }
            },
        },
        {
            title: <div>{t('CurrentData')}</div>,
            dataIndex: 'newValue',
            key: 'newValue',
            width: '33%',
            className: 'align-top',
            render: (value, row, index) => {
                switch (row.titleEn) {
                    case 'Logo':
                        return (
                            <>
                                {row?.newValue?.length > 0 ? (
                                    row?.newValue?.map((item) => {
                                        return (
                                            <img
                                                src={
                                                    getImage(item)
                                                        ? imageUrl
                                                        : imageUrl
                                                }
                                                className="object-cover w-auto h-20"
                                                alt={
                                                    lang === 'en'
                                                        ? 'Logo'
                                                        : 'โลโก้'
                                                }
                                            />
                                        );
                                    })
                                ) : (
                                    <div className="text-gray-600">-</div>
                                )}
                            </>
                        );
                    default:
                        return (
                            <>
                                {row?.newValue?.length > 0 ? (
                                    row?.newValue?.map((item) => {
                                        return (
                                            <p
                                                className="text-gray-600 whitespace-pre-line px-2"
                                                style={{
                                                    wordBreak: 'break-word',
                                                }}
                                            >
                                                {item !== 'null'
                                                    ? parse(item || '-')
                                                    : '-'}
                                            </p>
                                        );
                                    })
                                ) : (
                                    <div className="text-gray-600">-</div>
                                )}
                            </>
                        );
                }
            },
        },
    ];

    return (
        <div>
            <div className="title flex">
                <div
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        navigate(-1);
                    }}
                >
                    <IconBack />
                </div>
                {t('History')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">{t('Policy')} / </span>
                <span> {t('History')} </span>
            </div>
            <div className="bg-white rounded-xl p-4 my-4">
                <div className="grid grid-cols-2 p-4">
                    <div className="col-span-1">
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Name')} :
                            </div>
                            <div
                                className="col-span-8 pr-2"
                                style={{ wordBreak: 'break-word' }}
                            >
                                {i18n.language === 'en'
                                    ? decodeHtmlString(
                                          historyInfo?.nameEn ||
                                              historyInfo?.name ||
                                              '-'
                                      )
                                    : decodeHtmlString(
                                          historyInfo?.nameTh ||
                                              historyInfo?.name ||
                                              '-'
                                      )}
                            </div>
                        </div>
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('LogDate')} :
                            </div>
                            <div className="col-span-8">
                                {historyInfo?.logDate ?? '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Update By')} :
                            </div>
                            <div className="col-span-8">
                                {historyInfo?.logBy || '-'}
                            </div>
                        </div>
                    </div>
                    <div className="col-span-1">
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Version')} :
                            </div>
                            <div className="col-span-8">
                                {historyInfo?.version || '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Status')} :
                            </div>
                            <div className="col-span-8">
                                <span>{_getTagStatus(historyInfo)}</span>
                            </div>
                        </div>
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Action')} :
                            </div>
                            <div className="col-span-8">
                                {historyInfo?.action ? (
                                    <Tag
                                        className="rounded-xl -my-1 text-center px-4 text-white"
                                        color="#7B67FB"
                                    >
                                        {i18n.language === 'en'
                                            ? historyInfo?.action
                                            : historyInfo?.action}
                                    </Tag>
                                ) : (
                                    <>-</>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-xl p-4">
                <Table
                    bordered
                    className="inbox_table"
                    dataSource={historyInfo?.historyDifResponse || []}
                    columns={columns}
                    pagination={false}
                />
            </div>
            <div className="w-full text-right mt-4">
                <Pagination
                    current={currentPage?.page || 1}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={currentPage?.pageSize}
                    total={currentPage?.total || 1}
                    onChange={(page, pageSize) => {
                        const pageValue = {
                            ...currentPage,
                            page: page,
                            pageSize: pageSize,
                        };
                        setLoading(true);
                        setCurrentPage(pageValue);
                    }}
                    showSizeChanger
                />
            </div>
        </div>
    );
}
